<template>
  <div class="ma-2 ml-3 site_content">
    <div class="live-market-container">
      <h3>
        » 실시간 시장정보
      </h3>
      <div class="tab-container flex">
        <div class="tab-content">
          <button class="tab mr-1" 
            v-show="this.farmInfo.biz == 'CF02'"
            :class="{ active: selectedTab === '탕박' }" 
            @click="selectTab('탕박')">
            돼지
          </button>
          <button class="tab"
            v-show="this.farmInfo.biz == 'CF05'"
            :class="{ active: selectedTab === '한우' }" 
            @click="selectTab('한우')">
            한우
          </button>
          <button class="tab"
            v-show="this.farmInfo.biz == 'CF05' || this.farmInfo.biz == 'CF06'"
            :class="{ active: selectedTab === '육우' }" 
            @click="selectTab('육우')">
            육우
          </button>
        </div>
      </div>

      <div class="live-market-content">
        <div class="market-info">
          <div class="flex s-bt">
            <div class="flex">
              <div class="line mr-1"></div>
              <div class="market_title"> 전국 </div>
            </div>

            <div>
              <button class="refresh_btn" @click="infoMarket()">
								<v-icon color="white" class="mdi-18px">
										mdi-refresh
								</v-icon>
							</button>
            </div>
          </div>

          <div v-if="marketloading" class="loading-container">
            <div class="spinner"></div>
          </div>

          <div class="col flex" v-else>
            <div class="live-cost">
                <div class="cost-text">{{ this.market.cur_amt }}</div>
                <div class="unit ml-1 ">원/kg</div>

                <div class="ml-3" :class="this.market.cur_fluct < 0 ? 'blue-text':'red-text'">
                ( 
                  <span class="mb-3" :class="this.market.cur_fluct < 0 ? 'blue-text' : 'red-text'">
                    <span v-if="this.market.cur_fluct < 0">▼ {{ this.market.cur_fluct }}</span>
                    <span v-else>▲ {{ this.market.cur_fluct }}</span>
                  </span>
                )
              </div>
            </div>

            <div class="title_line mb-3 mt-3"></div>

            <div class="cost-info ">
              <div class="flex s-bt">
                <div> 시작가 </div>
                <div>
                  <span class="cost-value">{{ this.market.start_amt }}</span>
                  <span class="ml-2">원</span>
                </div>
              </div>

              <div class="flex s-bt mt-2">
                <div> 당일 최고가 </div>
                <div>
                  <span class="cost-value">{{ this.market.max_amt }}</span>
                  <span class="ml-2">원</span>
                </div>
              </div>

              <div class="flex s-bt mt-2">
                <div> 당일 최저가 </div>
                <div>
                  <span class="cost-value">{{ this.market.min_amt }}</span>
                  <span class="ml-2">원</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="market-chart"> 
          <div class="flex s-bt">
            <div class="flex">
              <div class="line mr-1"></div>
              <div class="market_title"> 
                실시간 
                <span v-show="this.selectedTab == '탕박'">돼지 가격 (탕박) </span>
                <span v-show="this.selectedTab == '한우'">한우 가격</span>
                <span v-show="this.selectedTab == '육우'">육우 가격</span>
              </div>
            </div>

            <div>
              <button class="refresh_btn" @click="infoMarket()">
								<v-icon color="white" class="mdi-18px">
										mdi-refresh
								</v-icon>
							</button>
            </div>
          </div>

          <div v-if="marketloading" class="loading-container">
            <div class="spinner"></div>
          </div>

          <div class="market_chart_layout" v-else>
            <Chart
              chartType="Bar"
              :chartData="chartData"
              :chartOptions="lineBarOptions"
              :chartSize="chartSize"
            />
          </div>
          <div style="font-size:12px; text-align: end;" >
            <a href="https://www.ekapepia.com/priceStat/realTimePrice.do?menuId=menu100003" target="_blank"
              style="color:#bababa; text-decoration: none;">
              출처 : 축산물 품질평가원
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="date_price_container">
      <h3>» 기간별 경락가격</h3>
      <div class="flex">
        <div class="tab-container flex">
          <div class="tab-content">
            <button class="tab mr-1" 
              v-show="this.farmInfo.biz == 'CF02'"
              :class="{ active: AmountTab === '탕박' }" 
              @click="listAmountTab('탕박')">
              탕박
            </button>
            <button class="tab mr-1" 
              v-show="this.farmInfo.biz == 'CF02'"
              :class="{ active: AmountTab === '박피' }" 
              @click="listAmountTab('박피')">
              박피
            </button>
            <button class="tab"
              v-show="this.farmInfo.biz == 'CF05'"
              :class="{ active: AmountTab === '한우' }" 
              @click="listAmountTab('한우')">
              한우
            </button>
            <button class="tab"
              v-show="this.farmInfo.biz == 'CF05' || this.farmInfo.biz == 'CF06'"
              :class="{ active: AmountTab === '육우' }" 
              @click="listAmountTab('육우')">
              육우
            </button>
            <button class="tab"
              v-show="this.farmInfo.biz == 'CF06'"
              :class="{ active: AmountTab === '젖소' }" 
              @click="listAmountTab('젖소')">
              젖소
            </button>
          </div>
        </div>
        
        <div class="flex">
          <div class="date-text">조회기간</div>
          <datePicker
            :fr_date="fr_date" 
            :to_date="to_date" 
            @update:fr_date="updateFrDate"
            @update:to_date="updateToDate"
          />
        </div>

        <div class="flex ml-3">
            <div class="date-text mr-3">성별</div>

            <div class="radio">
              <v-radio-group dense outlined row 
                id="sex" 
                ref="sex" 
                v-model="sex"
              >
                <v-radio label="전체" value="a" color="#9EB0A2"  />
                <v-radio label="암" value="f" color="#6B7B6E"/> 
                <v-radio label="수" value="m" color="#304E5C"/>
                <v-radio label="거세" value="x" color="#304E5C"/>  
              </v-radio-group>
            </div>
            
            <button class="refresh_btn mt-3" @click="refresh()">
              <v-icon color="white" class="mdi-18px">
                mdi-magnify
              </v-icon>
            </button>
          </div>
      </div>
    
      <div class="price_chart">
        <div v-if="loading" class="loading-container">
          <div class="spinner"></div>
        </div>
        <Chart
          v-else
          chartType="Line"
          :chart-options="lineChartOptions"
          :chart-data="pricechartData"
          :chartSize="chartSize"
        />
      </div>

      <div v-if="this.farmInfo.biz == 'CF02'">
        <div class="table_layout mt-2">
          <PigTable
            :headers="pig"
            :items="items"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            @update:sortBy="sortBy = $event"
            @update:sortDesc="sortDesc = $event"
          />
        </div>
        <div class="mt-2" style="font-size:12px;">
          <div>• 돼지 평균가격 <span class="blue-text">(등외 제외)</span>은 이전 경매일 대비 상승은 이전 경매일 대비 하락을 나타냄</div>
          <div>• 실시간 경매시황 중계는 <span class="blue-text">도매 시장과 축산물 품질 평가원 간 경배 내역 전송이 지연될 경우</span>가 있으므로 
            <span class="blue-text">금일의 거래현황을 참고하시는 자료</span>로 사용하시길 바라며, 정확한 경락 단가 및 두수는 
            <span class="red-text">기간별 경락가격을 참고</span>하시길 바랍니다.
          </div>
          <div>• 안동 봉화 축협은 전국 평균 가격에서 제외함.</div>
        </div>
      </div>

      <div v-else>
        <div class="table_layout mt-2">
          <CattleTable
            :headers="cattle"
            :items="items"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            @update:sortBy="sortBy = $event"
            @update:sortDesc="sortDesc = $event"
          />
        </div>
        <div class="mt-2" style="font-size:12px;">
            <div>• 소의 평균가격 <span class="blue-text">(등외 제외)</span>은 이전 경매일 대비 상승은 이전 경매일 대비 하락을 나타냄</div>
            <div>• 경락두수는 소(등외) 포함 두수를 나타냄 </div>
            <div>• 실시간 경매시황 중계는 도매시장과 축산물품질평가원간 경매내역 전송이 지연될 경우가 있으므로 금일의 거래현황을 참고하시는 자료로 사용하시기 바라며, 정확한 경락단가 및 두수는 기간별 경락가격을 참고하시기 바랍니다.</div>
          </div>
      </div>
    
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import Chart from "@/components/chart/Chart.vue"
import datePicker from "@/components/compo/datePicker_day.vue";

import { lineBarOptions, lineChartOptions } from "@/components/chart/option.js";  // 옵션 불러오기
import { getFarmInfo } from "@/components/cookie/farmcookie.js";
import PigTable from "@/views/trace/marketCostTable/pig.vue";
import CattleTable from "@/views/trace/marketCostTable/cattle.vue";


var setTime = 0;

export default {
name: 'Market',
components:{
    Chart,
    datePicker,
    PigTable,
    CattleTable
},
watch:{
	sex(newVal, oldVal) {
			if (newVal !== oldVal) this.refresh();
  }
},
data(){
  return{
    farmInfo: null,
    selectedTab:'탕박',
    AmountTab:'탕박',

    isMobile: false,
    sortBy: 'date',
    sortDesc: true,

    lineBarOptions:lineBarOptions,
    lineChartOptions:lineChartOptions,

    marketloading:false,
    loading:false,

    market:[],
    result:'',

    fr_date:"",
    to_date: "",

    liveinfo:[],
    marketData:{ hhmm:[], auctAmt:[] },
    chartData:{ },

    chartSize: {
      height:'20vh',
      width: '100%',
    },

    sex: 'a',
    
    items:[],

    pig: [
    { text: '경락일자', sortable: true, value: 'date'  },
    { text: '1+', value: 'grade1plus' },
    { text: '1', value: 'grade1' },
    { text: '2', value: 'grade2' },
    { text: '평균 (등외제외)', value: 'average' },
    { text: '등락', value: 'difference' },
    ],

    cattle: [
    { text: '경락일자', sortable: true, value: 'date'  },
    { text: '1++', value: 'grades1plus' },
    { text: '1+', value: 'grade1plus' },
    { text: '1', value: 'grade1' },
    { text: '2', value: 'grade2' },
    { text: '3', value: 'grade3' },
    { text: 'a', value: 'grade2' },
    { text: 'b', value: 'grade2' },
    { text: 'c', value: 'grade2' },
    { text: '전체', value: 'average' },
    { text: '등락', value: 'difference' },
    ],

  priceitems:{ date:[], plusa:[] , a:[], b:[]},
  pricechartData:{ }
  }
},
  async created(){
    Apis.pageCount({ //페이지뷰 카운터
      page_name: this.$route.name,
      url: this.$route.path,
      division: "cloud",
    },() => {  // 정상처리
    // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });

    this.FarmInfo();
    
    if (this.farmInfo.biz === 'CF02') {
      this.selectedTab = '탕박';
      this.AmountTab = '탕박';
    } else if(this.farmInfo.biz === 'CF05'){
      this.selectedTab = '한우';
      this.AmountTab = '한우';
    }else{
      this.selectedTab = '육우';
      this.AmountTab = '육우';
    }

    this.infoMarket();

    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.setDate(cdate.getDate() - 6));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

    await this.refresh();
  },
  destroyed() {
    clearTimeout(setTime);
    // console.log("clearTimeout",setTime);
  },
  methods:{
    FarmInfo(){
      const info = getFarmInfo();
      if (info.farm) {
        this.farmInfo = info.farm;
      } else {
        alert("쿠키에서 농장 정보를 가져오지 못했습니다.");
      }
    },
    selectTab(kind) {
      this.selectedTab = kind;
      this.infoMarket();
      // this.refresh();
    },
    listAmountTab(kind) {
      this.AmountTab = kind;
      this.refresh();
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    infoMarket(){
		this.marketloading = true;

		Apis.infoMarketRealTime({
      kind:this.selectedTab
      },(res) => {  
				this.result = res.resultCode;

        if (res.result) {
        this.market = res.data;
				this.liveinfo = res.data.amt_list;

				this.market.avg_amt = this.addCommas(this.market.avg_amt);
				this.market.cur_amt = this.addCommas(this.market.cur_amt);
				this.market.cur_fluct = this.addCommas(this.market.cur_fluct);
				this.market.max_amt = this.addCommas(this.market.max_amt);
				this.market.min_amt = this.addCommas(this.market.min_amt);
				this.market.start_amt = this.addCommas(this.market.start_amt);


				let hhmm = [];
				let auctAmt = [];
				let auctCnt = [];

				this.liveinfo.forEach(function (item){
					hhmm.push(item.hhmm)
					auctAmt.push(item.auctAmt)
					auctCnt.push(item.auctCnt)
				})

				this.marketData = {
					hhmm : hhmm,
					auctAmt : auctAmt,
					auctCnt : auctCnt
				}

				// this.refresh();
				this.chartData = this.drawChart();

				setTime = setTimeout( () => { 
					this.infoMarket();
				}, 5 * 60 * 1000);

				// console.log("setTime",setTime);
        this.$store.commit("resMessage",res.message);

				this.marketloading = false;
      } else {
				alert(res.message);
			}
      }).catch( (err) => {  // API 오류 처리
          console.log("infoMarketRealTime API 호출 오류",err)
					this.marketloading = false;
      })
	},
	drawChart(){
		// console.log(this.marketData)
		return{
			labels:this.marketData.hhmm,
			datasets: [
				{
					type: "line",
					label: '실시간 가격', 
					data:this.marketData.auctAmt,
					backgroundColor: 'rgba(90, 114, 160, 0.6)', 
					borderColor: 'rgba(90, 114, 160, 0.6)', 
					yAxisID: "y1",
				},
				{
					type: "bar",
					label: '실시간 거래량', 
					data:this.marketData.auctCnt,
					backgroundColor: 'rgba(174, 196, 247, 0.3)', 
					borderColor: 'rgba(174, 196, 247, 0.3)', 
					yAxisID: "y2",
				},
			]
		}
  },
  async refresh(){
		this.$store.commit("resMessage","");
		this.loading = true;

		Apis.listAmountHistoryPerDay({
			sex : this.sex,
			from : this.fr_date,
			to : this.to_date,
      kind : this.AmountTab,
      },(res) => {
        if (res.result) {
        // console.log(res.data)
        this.items = res.data;

				let date = [];
        let dataGrade = {};
        let allowedGrades;

        // 한우의 경우 표시할 등급 
        if(this.farmInfo.biz == 'CF02'){
          allowedGrades = ["1+", "1", "2"];
        }else{
          allowedGrades = ["1++", "1+", "1", "2", "3"];
        }
       

        allowedGrades.forEach((grade) => {
          dataGrade[grade] = [];
        });

        // 등급 있는거에 따라 데이터 처리
        this.items.forEach((item) => {
          date.push(item.date);

          // 값없으면 Null
          allowedGrades.forEach((grade) => {
            if (item.auct_amt[grade] !== undefined) {
              dataGrade[grade].push(item.auct_amt[grade]);
            } else {
              dataGrade[grade].push(null);
            }
          });
        });

        this.priceitems = {
          date,
          dataGrade,
        };


				// let plusa = [];
				// let a = [];
				// let b = [];

				// this.items.forEach(function (item){
				// 	// console.log(item)
				// 	date.push(item.date);
				// 	plusa.push(item.auct_amt["1+"]);
				// 	a.push(item.auct_amt["1"]);
				// 	b.push(item.auct_amt["2"]);
				// })

				// this.priceitems = {
				// 	date:date,
				// 	plusa:plusa,
				// 	a:a,
				// 	b:b
				// }
				// console.log(this.priceitems)

				this.pricechartData = this.drawPriceChart();
        // this.$store.commit("resMessage",res.message);
        } else {
          alert(res.message);
        }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("listAmountHistoryPerDay API 호출 오류",err);
          this.loading = false;
      })
	},
  drawPriceChart() {
    let allowedGrades = [];

    if(this.farmInfo.biz == 'CF02'){
      allowedGrades = ["1+", "1", "2"];
    }else{
      allowedGrades = ["1++", "1+", "1", "2", "3"];
    }

    const gradeLabels = {
      "etc": "등외",
      "1+": "1+",
      "1": "1",
      "2": "2",
      "3": "3",
      "1++": "1++",
    };
       
    // 동적으로 datasets 생성
    const datasets = allowedGrades.map((grade, index) => {
      const colors = [
        "rgba(90, 114, 160, 0.6)",
        "rgba(244, 209, 96, 0.6)",
        "rgba(131, 180, 255, 0.6)",
        "rgba(102, 153, 102, 0.6)",
        "rgba(255, 153, 153, 0.6)", 
      ];

      return {
        label: gradeLabels[grade] || grade,
        data: this.priceitems.dataGrade[grade],
        backgroundColor: colors[index % colors.length],
        borderColor: colors[index % colors.length],
      };
    });

    return {
      labels: this.priceitems.date,
      datasets,
    };
  },
  addCommas(num){
    if (typeof num === 'number') {
        return num.toLocaleString();
    }
    return num;
  },
  }
}
</script>

<style scoped lang="scss">
@import '../../style/base.scss';
@import '../../style/table_mb.scss';

.tab-container{
  align-items: center;
}
.tab-content {
  display: inline-flex;
  padding:5px;
  background-color: #F3F3F3;
  border-radius: 5px;
  overflow: hidden; /* 버튼이 탭 영역을 넘지 않도록 */
  height: 45px;
  line-height: 24px;
}

.tab {
  flex: 1;
  width:80px;
  border-radius: 20px;
  border: none;
  background-color: #e7e7e7;
  color: #bababa; 
  font-size: 15px !important;
  cursor: pointer;
  transition: all 0.5s ease;
}

.tab.active {
  background-color: $point-color; 
  color: white;
  font-weight:600;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2); 
}

.tab:not(.active):hover {
  background-color: #f0f0f0; 
}

.live-market-content{
  width:100%;
  display:flex;
}
.loading-container{
  height:20vh;
}
.market-info, .market-chart, .price_chart{
  background-color: white;
  border-radius: 5px;
  border: 1px solid #E9E9E9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding:20px;
}
.market-info{
  align-content: center;
  justify-content: center;
}
.market-info{
  min-width:29%;
  margin-right:10px;
  min-height:240px;
}
.market-chart{
  min-width:70%;
}
.market_title{
  font-size:1.3rem;
  margin-left:5px;
  font-weight: 600;
}
.live-cost{
  margin-top:10px;
  display:flex;
  align-items: center;
}
.cost-info{
  align-items: center !important;
  justify-content: space-between !important;
}
.cost-text{
  font-size:1.5rem;
  font-weight:600;
}
.unit{
  font-size:1.0rem;
  letter-spacing: -1px;
}
.live-cost .flex{
  align-items: center;
}
.cost-value{
  font-size:1.2rem;
  font-weight: 500;
}
.market_chart_layout{
  margin-top:10px;
}
.date_price_container{
  margin-top:15px !important;
}
.date_title{
  display: flex;
  align-items: center;
}
.date_title h3{
  width:250px;
}
.date-text{
  margin-top:15px;
  font-weight: 600;
}
.radio{
  margin-top:5px;
  padding:0 10px;
  height:45px !important;
  background-color: white;
  border-radius: 50px !important;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
.v-input--selection-controls{
  margin-top:7px !important;
}
.table_layout{
  border-radius: 5px !important;
  padding:0 !important;
  margin-top:10px;
  overflow: hidden;
  // height:29vh;
  // min-height:250px;
}


@media only screen and (max-width: 768px) {
  .live-market-content{
    display: block;
  }
  .market-info{
    width:100%;
  }
  .market-chart{
    width:100%;
    margin-top:10px;
  }
  .price-flex, .date_title{
    flex-direction: column !important;
  }
  .date_title h3{
    width:380px;
  }
  .date-text{
    display: none;
  }
  .radio{
    margin-top:5px;
    padding: 0 5px !important;
  }
  .v-radio{
    margin-right:5px !important;
  }
}
</style>